import * as types from './types';

const initialState = {
  user: null,
  loading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_REQUEST:
      return { ...state, loading: true, error: null };
    case types.AUTH_SUCCESS:
      return { ...state, loading: false, user: action.payload, error: null };
    case types.AUTH_FAIL:
      return { ...state, loading: false, error: action.payload };
    case types.AUTH_LOGOUT:
      return { ...state, user: null, loading: false, error: null };
    case types.CLEAR_AUTH_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default authReducer;
